import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import * as routes from '../../../routes/const';

import { NitroHeading, NitroButtonGroup, NitroButton, NitroParagraph, NitroPanel, NitroIcon } from 'nitro-components';

import HelpText from '../../../components/utils/HelpText';

import styled from 'styled-components';
import Header from '../../../components/layouts/Header';

const IconWrapper = styled.div`
  line-height: 48px;
  margin-bottom: 20px;
`;

const CenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MessageWrapper = styled.div`
  margin-bottom: 20px;
  line-height: 22px;
`;

class QuoteSubmitted extends Component {

  componentWillMount() {
    const { updateStep } = this.props.actions;

    updateStep(0);
  }

  // E.T
  goHome = () => {
    this.context.router.push(routes.HOME);
  };

  render() {
    const { hasSubmitted, quoteId, submitSuccess } = this.props;
    const { router } = this.context;

    if (!hasSubmitted) {
      router.push(routes.HOME);
    }

    return (
      <div>

        <Header margin="32px 0" lineHeight={32}>
          <NitroHeading label="Quote Submission" variant="secondary" align="center" size="1" />
        </Header>

        <NitroPanel padding="48px 24px">
          <CenterWrapper>
            {submitSuccess &&
            <IconWrapper>
              <NitroIcon name="success" size={48} variant="success" />
            </IconWrapper>
            }
           {!submitSuccess &&
            <IconWrapper>
              <NitroIcon name="filled-warning" size={48} variant="base3" />
            </IconWrapper>
            }

           
            {submitSuccess &&
              <div>
               <NitroHeading label="Thank you!" size="2" align="center" noMargin />
              <NitroHeading label={`Quote ref. ${quoteId} has been successfully submitted.`} size="2" align="center" />
              </div>
            }
            {!submitSuccess &&
               <NitroHeading label={`Sorry, submission of Quote ref. ${quoteId} was unsucessful`} size="2" align="center" />
            }
          </CenterWrapper>

          <MessageWrapper>
           {submitSuccess &&
            <NitroParagraph size="3" align="center" noMargin>
              Your quote will now be reviewed and proccessed.
            </NitroParagraph>
          }
            <NitroParagraph size="3" align="center" noMargin><HelpText /></NitroParagraph>

          </MessageWrapper>

          <NitroButtonGroup maxWidth={300} align="center" layout="horizontal">
            <NitroButton label="Back to dashboard" action={this.goHome} size="small" variant="primary" block />
          </NitroButtonGroup>
        </NitroPanel>

      </div>
    );
  }
}

QuoteSubmitted.propTypes = {
  actions: PropTypes.object.isRequired,
  hasSubmitted: PropTypes.bool.isRequired,
  quoteId: PropTypes.string.isRequired,
  submitSuccess: PropTypes.bool.isRequired
};

QuoteSubmitted.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  quoteId: state.corporateQuote.create.quoteId,
  hasSubmitted: state.corporateQuote.create.hasSubmitted,
  submitSuccess: state.corporateQuote.create.submitSuccess
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(QuoteSubmitted);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/QuoteSubmitted.js